module.exports = __webpack_public_path__ + "img/wbs.fd390e7e.svg";